export const FORMS_LOADED = "forms/formsLoaded"
export const FORM_ADDED = "forms/formAdded"
export const FORM_UPDATED = "forms/formUpdated"
export const FORM_DELETED = "forms/formDeleted"